import PropTypes from 'prop-types';
import React from 'react';

import FormManager from '../../gd-form/common/form-manager';
import Form from '../../gd-form/form/form-modal-new/form-modal-new.tsx';
import DatePicker from '../../gd-form/form-element/datepicker/datepicker-new.jsx';

import Moment from 'moment';

class ModalActionsStartEnd extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        item: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const { item } = props;

        this.state = {
            startDate: item && item.startDate ? Moment(item.startDate) : null,
            endDate: item && item.endDate ? Moment(item.endDate) : null
        };
    }

    UNSAFE_componentWillMount() {
        const { startDate, endDate } = this.state;

        const initFormData = {
            startDate: startDate,
            endDate: endDate
        };

        const formStructure = {
            fields: {
                startDate: {
                    type: 'select',
                    isRequired: true,
                    onUserChange: this.onStartDateChange
                },
                endDate: {
                    type: 'select',
                    isRequired: true,
                    onUserChange: this.onEndDateChange
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onStartDateChange = () => {
        const { startDate, endDate } = this.state;

        const newStartDate = this.form.getValue("startDate");

        const endStartDiff = endDate ? Moment(endDate).diff(Moment(startDate ? startDate : newStartDate), 'days') : 0;
        let newEndDate;
        if (endStartDiff > 0)
            newEndDate = endDate ? Moment(newStartDate).add(endStartDiff,'days') : null;
        else
            newEndDate = Moment(newStartDate);

        this.form.setValue("endDate", newEndDate);

        this.setState({
            startDate: newStartDate,
            endDate: newEndDate
        });
    };

    onEndDateChange = () => {
        this.setState({
            endDate: this.form.getValue("endDate")
        });
    };

    onSubmit = (result) => {
        this.props.onSubmit(result);
    };

    render() {
        const startDate = this.form.getValue("startDate");

        return (
            <Form className="start-end-dates-form" form={this.form} submitBtnClass="grey" submitLabel="Save" >

                <div className="tbl">

                    <div className="row">
                        <div className="label">Start date:</div>
                        <div className="element">
                            <DatePicker className="start-date"
                                        form={this.form}
                                        name="startDate"
                                        humanizeValue={false}
                                        placeholderText="Select date"
                                        valueFormat="MMM DD, YYYY"
                                        inline={true}/>
                        </div>

                    </div>

                    <div className="row">
                        <div className="label">End date:</div>
                        <div className="element">
                            <DatePicker className="end-date"
                                        form={this.form}
                                        name="endDate"
                                        minDate={startDate}
                                        humanizeValue={false}
                                        placeholderText="Select date"
                                        valueFormat="MMM DD, YYYY"
                                        inline={true}/>
                        </div>

                    </div>
                </div>



            </Form>
        );
    }
}

module.exports = ModalActionsStartEnd;